export default __webpack_public_path__ + "static/media/git-icon.fd381642.svg";